/** 列表页查询条件内存缓存（同模块子路由返回时恢复） */

const store = Object.create(null);

function clone(value) {
  if (value === undefined || value === null) return value;
  return JSON.parse(JSON.stringify(value));
}

export function saveListQuery(cacheKey, query) {
  if (!cacheKey || !query) return;
  store[cacheKey] = clone(query);
}

export function getListQuery(cacheKey) {
  if (!cacheKey || !store[cacheKey]) return null;
  return clone(store[cacheKey]);
}

export function clearListQuery(cacheKey) {
  if (!cacheKey) return;
  delete store[cacheKey];
}

/** 是否从同模块子路由返回（用于决定是否恢复缓存） */
export function isReturnFromChild(toPath, fromPath, parentPath) {
  const parent = normalize(parentPath);
  const to = normalize(toPath);
  const from = normalize(fromPath);
  if (!parent || to !== parent) return false;
  return from === parent || from.startsWith(parent + "/");
}

function normalize(path) {
  if (!path) return "";
  const p = String(path).split("?")[0].replace(/\/+/g, "/");
  if (p.length > 1 && p.endsWith("/")) return p.slice(0, -1);
  return p;
}



// WEBPACK FOOTER //
// ./src/utils/listQueryCache.js